var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgModal2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 322,
    height: 193,
    viewBox: "0 0 322 193",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.0267 71.2028L107.809 10.9774L168.592 71.2028",
    stroke: "#B4B9C8",
    strokeWidth: 1.9,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M279.797 71.2028H168.592L107.809 10.9774H232.199L279.797 71.2028Z",
    stroke: "#B4B9C8",
    strokeWidth: 1.9,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M261.995 71.3295V87.8511H57.4983V60.8273",
    stroke: "#B4B9C8",
    strokeWidth: 1.9,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M123.977 41.3119H91.6419V78.8379H123.977V41.3119Z",
    stroke: "#B4B9C8",
    strokeWidth: 1.9,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M107.809 41.3119V78.8379",
    stroke: "#B4B9C8",
    strokeWidth: 1.9,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M103.303 60.8273H112.712",
    stroke: "#B4B9C8",
    strokeWidth: 1.9,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M183.966 124.474H151.631V162H183.966V124.474Z",
    stroke: "#B4B9C8",
    strokeWidth: 1.9,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M167.799 124.474V162",
    stroke: "#B4B9C8",
    strokeWidth: 1.9,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M163.293 143.974H172.701",
    stroke: "#B4B9C8",
    strokeWidth: 1.9,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M238.307 124.474H205.972V162H238.307V124.474Z",
    stroke: "#B4B9C8",
    strokeWidth: 1.9,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M222.14 124.474V162",
    stroke: "#B4B9C8",
    strokeWidth: 1.9,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M217.634 143.974H227.042",
    stroke: "#B4B9C8",
    strokeWidth: 1.9,
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M202.958 10.9774H180.777V41.0901H202.958V10.9774Z",
    stroke: "#B4B9C8",
    strokeWidth: 1.9,
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M207.479 1.50488H175.509V10.9775H207.479V1.50488Z",
    stroke: "#B4B9C8",
    strokeWidth: 1.9,
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1528 87.8511H270.277C270.277 93.2368 265.898 97.6088 260.503 97.6088H58.9421C53.5477 97.6088 49.1687 93.2368 49.1687 87.8511H49.1528Z",
    stroke: "#B4B9C8",
    strokeWidth: 1.9,
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M261.995 97.6089H57.4983V188.834H261.995V97.6089Z",
    stroke: "#B4B9C8",
    strokeWidth: 1.9,
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M123.977 114.273H78.1082V171.33H123.977V114.273Z",
    stroke: "#B4B9C8",
    strokeWidth: 1.9,
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M130.006 171.314H72.095V179.821H130.006V171.314Z",
    stroke: "#B4B9C8",
    strokeWidth: 1.9,
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M134.401 179.821H67.2083V188.327H134.401V179.821Z",
    stroke: "#B4B9C8",
    strokeWidth: 1.9,
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M97.671 120.514H84.883V136.656H97.671V120.514Z",
    stroke: "#B4B9C8",
    strokeWidth: 1.9,
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M117.218 120.514H104.43V136.656H117.218V120.514Z",
    stroke: "#B4B9C8",
    strokeWidth: 1.9,
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M261.995 76.5886H187.536",
    stroke: "#B4B9C8",
    strokeWidth: 1.9,
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M180.777 76.5886H172.511",
    stroke: "#B4B9C8",
    strokeWidth: 1.9,
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M120.232 23.2854H159.723",
    stroke: "#B4B9C8",
    strokeWidth: 1.9,
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M148.442 34.9124H172.511",
    stroke: "#B4B9C8",
    strokeWidth: 1.9,
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M219.125 34.9124H242.448",
    stroke: "#B4B9C8",
    strokeWidth: 1.9,
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M172.511 53.6832H230.787",
    stroke: "#B4B9C8",
    strokeWidth: 1.9,
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M246.208 53.6832H256.362",
    stroke: "#B4B9C8",
    strokeWidth: 1.9,
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M217.634 63.0767H253.729",
    stroke: "#B4B9C8",
    strokeWidth: 1.9,
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M148.252 167.449H187.361",
    stroke: "#B4B9C8",
    strokeWidth: 1.9,
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M202.402 167.449H241.512",
    stroke: "#B4B9C8",
    strokeWidth: 1.9,
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M117.218 149.866C117.218 151.625 115.79 153.05 114.029 153.05C112.268 153.05 110.84 151.625 110.84 149.866C110.84 148.108 112.268 146.682 114.029 146.682C115.79 146.682 117.218 148.108 117.218 149.866Z",
    stroke: "#B4B9C8",
    strokeWidth: 1.9,
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M274.529 188.85H261.995V153.05L268.262 145.542L274.529 153.05V188.85Z",
    stroke: "#B4B9C8",
    strokeWidth: 1.9,
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M294.092 188.85H281.558V153.05L287.825 145.542L294.092 153.05V188.85Z",
    stroke: "#B4B9C8",
    strokeWidth: 1.9,
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M313.639 188.85H301.105V153.05L307.372 145.542L313.639 153.05V188.85Z",
    stroke: "#B4B9C8",
    strokeWidth: 1.9,
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4204 188.85H5.88628V153.05L12.1533 145.542L18.4204 153.05V188.85Z",
    stroke: "#B4B9C8",
    strokeWidth: 1.9,
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9832 188.85H25.449V153.05L31.7161 145.542L37.9832 153.05V188.85Z",
    stroke: "#B4B9C8",
    strokeWidth: 1.9,
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M57.53 188.85H44.9959V153.05L51.263 145.542L57.53 153.05V188.85Z",
    stroke: "#B4B9C8",
    strokeWidth: 1.9,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModal2);
export default __webpack_public_path__ + "static/media/modal2.bdcc3fe6b3961dc0ea516a77d104adf5.svg";
export { ForwardRef as ReactComponent };